import * as fromDatatype from '../datatype-library/index';

export interface Bl_inv_stock_take_session_report_line_RowInterface {
  guid: string;
  guid_session: string;
  input_string: string;
  guid_item: string;
  item_code: string;
  item_name: string;
  guid_bin: string;
  date_start: Date;
  date_end: Date;
  sys_bal_start: number;
  sys_bal_end: number;
  sys_txn_qty_with_time: number;
  sys_txn_qty_with_date: number;
  qty_counted_sum: number;
  qty_calc_min: number;
  qty_calc_max: number;
  qty_calc_adjust: number;
  action_logic: string;
  action_adjust_type: string;
  action_adjust_qty: number;
  action_adjust_status: string;
  action_adjust_reference_no: string;
  action_adjust_remarks: string;
  action_adjust_doc_hdr: string;
  action_adjust_doc_line: string;
  remarks: string;
  status: string;
  vrsn: string;
  revision: string;
  property_json: fromDatatype.JsonDatatypeInterface;
  uom_json: fromDatatype.JsonDatatypeInterface;
  unit_cost_method: fromDatatype.VarcharDatatypeInterface;
  unit_cost_value: fromDatatype.NumericDatatypeClass;
  sys_bal_sn: fromDatatype.VarcharDatatypeInterface;
  stocktake_sn: fromDatatype.VarcharDatatypeInterface;
  base_uom: fromDatatype.VarcharDatatypeInterface;
  qty_uom: fromDatatype.NumericDatatypeInterface;
  ean_code: fromDatatype.VarcharDatatypeInterface;
  uom_ratio: fromDatatype.NumericDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
}

export class Bl_inv_stock_take_session_report_line_RowClass implements Bl_inv_stock_take_session_report_line_RowInterface {
  guid: string;
  guid_session: string;
  input_string: string;
  guid_item: string;
  item_code: string;
  item_name: string;
  guid_bin: string;
  date_start: Date;
  date_end: Date;
  sys_bal_start: number;
  sys_bal_end: number;
  sys_txn_qty_with_time: number;
  sys_txn_qty_with_date: number;
  qty_counted_sum: number;
  qty_calc_min: number;
  qty_calc_max: number;
  qty_calc_adjust: number;
  action_logic: string;
  action_adjust_type: string;
  action_adjust_qty: number;
  action_adjust_status: string;
  action_adjust_reference_no: string;
  action_adjust_remarks: string;
  action_adjust_doc_hdr: string;
  action_adjust_doc_line: string;
  remarks: string;
  status: string;
  vrsn: string;
  revision: string;
  property_json: fromDatatype.JsonDatatypeInterface;
  uom_json: fromDatatype.JsonDatatypeInterface;
  unit_cost_method: fromDatatype.VarcharDatatypeInterface;
  unit_cost_value: fromDatatype.NumericDatatypeClass;
  sys_bal_sn: fromDatatype.VarcharDatatypeInterface;
  stocktake_sn: fromDatatype.VarcharDatatypeInterface;
  base_uom: fromDatatype.VarcharDatatypeInterface;
  qty_uom: fromDatatype.NumericDatatypeInterface;
  ean_code: fromDatatype.VarcharDatatypeInterface;
  uom_ratio: fromDatatype.NumericDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
}
